// El prompt clínico se conserva literalmente y en el mismo orden. El corte
// queda ANTES del primer dato del paciente, en el encabezado que buildPrompt
// genera siempre. El modo rápido/detallado sí pertenece al prefijo estable.
const INICIO = '═══ REGLAS OBLIGATORIAS DE GENERACIÓN DE DIAGNÓSTICOS';
const CORTE = '\n\n═══ EVENTOS ACTIVOS DEL TURNO ═══\n';

export function bloquesCacheDiagnosticos(system) {
  if (typeof system !== 'string' || !system.startsWith(INICIO)) return null;
  const posicion = system.indexOf(CORTE);
  if (posicion <= 0) return null;
  // Ambos bloques conservan el TTL de 5 minutos. El segundo mantiene el
  // breakpoint que ya existía al final: no se extiende la zona cacheada a
  // mensajes del paciente ni se agrega una llamada para precalentarla.
  // En un miss completo se escribe el mismo contenido, no el prefijo dos
  // veces. Con otro paciente se puede reutilizar solo el primer bloque.
  return [system.slice(0, posicion), system.slice(posicion)].map(text => ({
    type: 'text', text, cache_control: { type: 'ephemeral' },
  }));
}
